export default class UploadControl {
    /**
     * Constructor
     * @param $field
     */
    constructor($field) {
        this.$control = $field.querySelector('[data-upload-control]');
        this.$files = $field.querySelector('[data-file-upload-names]');
        this.$noFiles = $field.querySelector('[data-file-upload-no-files]');
        this.$hiddenControl = $field.querySelector('[data-upload-hidden-input]');

        this.addFile = this.addFile.bind(this);
        this.deleteFile = this.deleteFile.bind(this);

        this.$control.addEventListener('change', this.addFile);

        document.addEventListener("click", (e) => {
            const target = e.target.closest("[data-delete-file]"); // Or any other selector.

            if(target) {
                this.deleteFile(e, target);
            }
        });
    }

    /**
     * Add File
     * @param e
     */
    addFile(e) {
        const files = this.$control.files;
        this.$hiddenControl.value = '';
        this.$noFiles.classList.add('d-none')

        for (var i = 0; i < files.length; i++) {
            const file = files[i];
            const fileId = file.name + file.lastModified;
            this.$files.innerHTML =
                    '<div class="file-upload__file" data-file="' + fileId +'">\n' +
                    '    <div class="file-upload__name">\n' +
            '        <i class="icon-file file-upload__file-icon"></i>' + file.name +
            '        <a href="#" class="file-upload__delete icon-button" data-delete-file="' + fileId +'">\n' +
            '            <i class="icon-cross"></i>\n' +
            '        </a>\n' +
            '    </div>\n' +
            '</div>';
        }
    }

    /**
     * Delete file
     *
     * @param e
     * @param $target
     */
    deleteFile(e, $target) {
        e.preventDefault();

        const fileId = $target.dataset.deleteFile;
        const dt = new DataTransfer()
        const { files } = this.$control;
        this.$hiddenControl.value = '';

        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            if ((file.name + file.lastModified) !== fileId) {
                dt.items.add(file) // here you exclude the file. thus removing it.
            }
        }

        this.$control.files = dt.files // Assign the updates list

        // make the file list empty
        this.$files.querySelector('[data-file="' + fileId + '"]').remove();

        if (! dt.files.length) {
            this.$noFiles.classList.remove('d-none');
        }
    }
}
